import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import {
  DriveTreeNode,
  SyllabusTreeNode,
} from './drive.types';

@Component({
    selector: 'app-resource-drive-sidebar',
    templateUrl: './drive-sidebar.component.html',
    styleUrls: ['./drive-sidebar.component.scss'],
    standalone: false
})
export class ResourceDriveSidebarComponent implements OnChanges {
  @Input() treeNodes: DriveTreeNode[] = [];
  @Input() expandedKeys: string[] = [];
  @Input() selectedKeys: string[] = [];
  @Input() sidebarError: string | null = null;
  @Input() loading = false;

  internalExpandedKeys: string[] = [];

  @Output() folderSelect = new EventEmitter<{ pathIds: number[]; node: SyllabusTreeNode | null }>();
  @Output() expandedKeysChange = new EventEmitter<string[]>();
  @Output() retryCategory = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['expandedKeys']) {
      this.internalExpandedKeys = [...(this.expandedKeys || [])];
    }
  }

  onExpandChange(event: NzFormatEmitEvent): void {
    const key = event.node?.key;
    if (!key) {
      return;
    }
    const next = new Set(this.internalExpandedKeys);
    if (event.node?.isExpanded) {
      next.add(key);
    } else {
      next.delete(key);
    }
    this.internalExpandedKeys = Array.from(next);
    this.expandedKeysChange.emit(this.internalExpandedKeys);
  }

  onTreeClick(event: NzFormatEmitEvent): void {
    if (event.eventName !== 'click') {
      return;
    }
    const origin = event.node?.origin as DriveTreeNode | undefined;
    if (!origin?.pathIds) {
      return;
    }
    this.folderSelect.emit({ pathIds: [...origin.pathIds], node: origin.origin });
  }
}
